module.exports = __webpack_public_path__ + "static/img/smartphone.839eef80.png";